var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "deed-owner-holder-edit-wrapper" }, [
    _c(
      "form",
      {
        attrs: {
          autocomplete: "off",
          method: "post",
          "data-vv-scope": _vm.vScope,
        },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return (() => {
              return false
            }).apply(null, arguments)
          },
          submit: function ($event) {
            $event.preventDefault()
            return (() => {
              return false
            }).apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-sm-6 col-xl-3" },
            [
              _c(
                "MaterialSelect",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("deed_owner_holder_start_type_id"),
                      expression:
                        "rulesField('deed_owner_holder_start_type_id')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-holder_start_type",
                    name: "holder_start_type",
                    label: "name",
                    options: _vm.start_types,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "holder_start_type",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("holder_start_type", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.deed_owner_holder_start_type_id,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "deed_owner_holder_start_type_id",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.deed_owner_holder_start_type_id",
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.start_type`)) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-sm-6 col-xl-3" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialDatePicker",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("deed_owner_holder_start_at"),
                        expression: "rulesField('deed_owner_holder_start_at')",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: _vm.readonlyForm,
                      id: "input-holder_start_at",
                      name: "holder_start_at",
                      dateFormat: _vm.labelDateFormat,
                      databaseDateFormat: _vm.dateFormat,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "holder_start_at",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("holder_start_at", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.deed_owner_holder_start_at,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "deed_owner_holder_start_at",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.deed_owner_holder_start_at",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.start_at`)) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-sm-6 col-xl-3" },
            [
              _c(
                "MaterialSelect",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("deed_owner_holder_end_type_id"),
                      expression: "rulesField('deed_owner_holder_end_type_id')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-holder_end_type",
                    name: "holder_end_type",
                    label: "name",
                    options: _vm.end_types,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "holder_end_type",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("holder_end_type", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.deed_owner_holder_end_type_id,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "deed_owner_holder_end_type_id",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.deed_owner_holder_end_type_id",
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.end_type`)) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-sm-6 col-xl-3" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialDatePicker",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("deed_owner_holder_end_at"),
                        expression: "rulesField('deed_owner_holder_end_at')",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: _vm.readonlyForm,
                      id: "input-holder_end_at",
                      name: "holder_end_at",
                      dateFormat: _vm.labelDateFormat,
                      databaseDateFormat: _vm.dateFormat,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "holder_end_at",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("holder_end_at", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.deed_owner_holder_end_at,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "deed_owner_holder_end_at",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.deed_owner_holder_end_at",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.end_at`)) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 entity" }, [
            _c("h6", { staticClass: "header" }, [
              _vm._v(_vm._s(_vm.$t(`${_vm.translateID}.form.entity`))),
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "mt-1 mb-3" }),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("EntityDetails", {
                    attrs: {
                      additional: _vm.additional,
                      panelCfg: _vm.panelCfg,
                      vScope: _vm.vScope,
                      readonlyForm: _vm.readonlyForm,
                      action: _vm.onlySelectAndViewAction,
                      baseTranslateID: "entities",
                      genders: _vm.genders,
                      religions: _vm.religions,
                      causes_death: _vm.causes_death,
                    },
                    model: {
                      value: _vm.form.entity,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "entity", $$v)
                      },
                      expression: "form.entity",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }